export default {
  'globalHeader.avatar.changePwd': '修改密码',
  'globalHeader.changePwd.title': '修改密码',
  'globalHeader.changePwd.oldPassword': '旧密码',
  'globalHeader.changePwd.oldPassword.required': '请输入旧密码',
  'globalHeader.changePwd.newPassword': '新密码',
  'globalHeader.changePwd.newPassword.required': '请输入新密码',
  'globalHeader.changePwd.success': '修改成功,请重新登录',
};
